<template>
  <div class="top">
    <resetPassword
      v-if="resetPasswordFlag"
      :flag="resetPasswordFlag"
      :passwdcur="reset.passwdcur"
      :passwdnew="reset.passwdnew"
      :passwdagain="reset.passwdagain"
      @close="closeReset"></resetPassword>
    <div class="left">
      <img :src="require('../../common/img/logo.png')" class="logo">
    </div>
    <div class="right">
      <p class="tips">欢迎使用小果互动广告主后台！</p>
      <div class="login-info" >
        <el-dropdown class="username-info" @command="handleCommand">
          <el-button :title="username" class="username__text">
            <i data-v-7b333ae1="" class="iconfont icon-yonghu2"></i>
            <span class="name">{{ username }}</span>
            <i class="iconfont icon-xia"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <div class="dropdown-item-box" v-if="usersource !== 0">
              <el-dropdown-item command="切换账户" @mouseover="showCustoms" @mouseleave="hideCustoms" ><i data-v-7b333ae1="" class="iconfont icon-qiehuanzhanghao"></i>&nbsp;&nbsp;切换账户</el-dropdown-item>
              <transition name="customs">
                <ul class="customs" v-if="customsStatus">
                  <li class="custom-item" v-for="item in subCustoms" :key="item.id" @click="chooseSubCustomer(item)" >
                    <span :class="['custom-item__text', {'active':item.id === subCustomerId}]" :title="item.name">{{ item.name }}<i class="iconfont icon-renzhengtongguo" v-if="item.id === subCustomerId"></i></span>
                  </li>
                </ul>
              </transition>
            </div>
            <el-dropdown-item command="更改密码" v-show="usersource !== 2"><i data-v-7b333ae1="" class="iconfont icon-xiugai"></i>&nbsp;&nbsp;修改密码</el-dropdown-item>
            <el-dropdown-item command="退出登陆"><i data-v-7b333ae1="" class="iconfont icon-tuichu"></i>&nbsp;&nbsp;退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <transition name="successTips">
      <div class="successTips" v-if="successTips">
        <p class="tips-words">修改成功，请重新登陆</p>
      </div>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'
import storage from '../../common/js/localstorage'
import resetPassword from '../public/reset-password.vue'

export default {
  data () {
    return {
      usersource: 1,
      username: '',
      resetPasswordFlag: false,
      successTips: false,
      customsStatus: false,
      subCustomerId: '',
      reset: {
        passwdcur: '',
        passwdnew: '',
        passwdagain: ''
      },
      subCustoms: []
    }
  },
  methods: {
    // 账户操作
    handleCommand (command) {
      if (command === '更改密码') {
        this.resetPasswordFlag = true
      } else if (command === '退出登陆') {
        
        this.$http.post(this.$root.urlPath.MJK + '/user/logout').then(res => {
          if (res.data.status === 201) {
            storage.delete('usersource')
            storage.delete('username')
            storage.delete('agentEmail')
            storage.delete('agentId')
            storage.delete('companyName')
            this.$router.replace({
              path: '/login',
              query: {
                redirect: this.$route.fullPath
              }
            })
          } else {
            this.$message.error('登出失败')
          }
        })
      }
    },
    succcess () {
      this.successTips = true
      setTimeout(() => {
        this.successTips = false
        this.$router.replace({
          path: '/login',
          query: {
            redirect: this.$route.fullPath
          }
        })
      }, 2000)
    },
    // 关闭弹窗
    closeReset (tag) {
      this.resetPasswordFlag = false
      if (tag) {
        this.succcess()
      }
    },
    // 展示子账户列表
    showCustoms () {
      this.customsStatus = true
    },
    // 隐藏子账户列表
    hideCustoms () {
      this.customsStatus = false
    },
    // 选择子账户
    chooseSubCustomer (subCustomer) {
      // this.username = subCustomer.name
      this.customsStatus = false
      this.subCustomerId = subCustomer.id
      this.$http.post(this.$root.urlPath.MJK + '/user/ChangeLogin', qs.stringify({
        account: subCustomer.account
      })).then(result => {
        const res = result.data
        if (res.status === 100) {
          this.$router.replace({
            path: '/dataGovern'
          })
          storage.set('usersource', res.userSource)
          storage.set('username', res.CompanyName)
          setTimeout(() => {
            window.location.reload()
          }, 500);
        }
      })
    },
    // 获取子用户列表信息
    getSubUserList () {
      this.subCustoms[0] = {
        id: storage.get('agentId'),
        name: storage.get('companyName'),
        account: storage.get('agentEmail')
      }
      this.username = this.subCustoms[0].name
      this.$http.post(this.$root.urlPath.MJK + '/user/GetSubUserList').then(result => {
        const res = result.data
        res.data.forEach((item, i) => {
          const subFirm = {
            id: item.UserId,
            name: item.CompayName,
            account: item.UserEmail
          }
          this.subCustoms[i+1] = subFirm
        })
      })
    }
  },
  components: {
    resetPassword
  },
  mounted () {
    this.getSubUserList()
    document.querySelector('.dropdown-item-box') && document.querySelector('.dropdown-item-box').addEventListener('mouseenter', () => {
      this.customsStatus = true
    })
    document.querySelector('.dropdown-item-box') && document.querySelector('.dropdown-item-box').addEventListener('mouseleave', () => {
      this.customsStatus = false
    })
    this.usersource = storage.get('usersource')
    this.username = storage.get('username')
    console.log(this.subCustoms)
  }
}
</script>

<style lang="scss" scoped>
  @import '../../common/scss/color.scss';

  @media screen and (max-width: 1600px) {
    .top {
      height: 70px;
    }
  }
  @media screen and (min-width: 1601px) {
    .top {
      height: 97px;
    }
  }
  .top {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: $mainColor;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    .left {
      width: 183px;
      height: 100%;
      position: relative;
      .logo {
        position: absolute;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
    .right {
      height: 100%;
      display: flex;
      justify-content: space-around;
      flex-wrap: nowrap;
      align-items: center;
      margin-right: 338px;
      .tips {
        color: white;
        font-size: 14px;
        padding-right: 20px;
      }
      .login-info {
        height: 100%;
      }
      .username-info {
        font-size: 18px;
        width: 193px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        .el-button {
          padding: 0 23px;
          width: 100%;
          padding: 0;
          height: 100%;
          background-color: $mainColor;
          border: none;
          color: white;
          font-size: 18px;
          .name {
            display: inline-block;
            width: 70%;
            height: 24px;
            line-height: 24px;
            text-overflow:ellipsis;
            white-space:nowrap;
            overflow: hidden;
          }
          .iconfont {
            display: inline-block;
            height: 24px;
            line-height: 24px;
            overflow: hidden;
          }
          &:hover {
            background-color: #ff9d20;
          }
        }
      }
    }
  }
  .el-dropdown-menu {
    width: 193px;
    padding: 0;
    box-shadow: 0 0 30px #e0e0e0;
    .customs {
      background-color: #fff;
      position: absolute;
      top: 0;
      right: 193px;
      width: 220px;
      font-size: 16px;
      box-shadow: 0 0 3px #e0e0e0;
      .custom-item {
        cursor: pointer;
        height: 53px;
        color: #777;
        & + .custom-item {
          border-top: 1px solid #f8f9fa;
        }
        .custom-item__text {
          display: inline-block;
          box-sizing: border-box;
          width: 220px;
          height: 35px;
          line-height: 35px;
          padding: 0 18px ;
          margin-top: 9px;
          text-overflow:ellipsis;
          white-space:nowrap;
          overflow: hidden;
          &:hover {
            background-color: #f8f9fa;
            color: #666;
          }
          &.active {
            background-color: $mainColor;
            color: #fff;
          }
          .iconfont {
            float: right;
          }
        }
      }
    }
    .el-dropdown-menu__item {
      font-size: 18px;
      text-align: center;
      color: #666;
      height: 54px;
      line-height: 54px;
      &:hover {
        background-color: #fff;
        color: $mainColor;
      }
    }
  }
  .successTips {
    width: 227px;
    height: 89px;
    line-height: 89px;
    text-align: center;
    position: fixed;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    color: $mainColor;
    font-size: 20px;
    background-color: #fff;
    box-shadow: 0 0 30px #e0e0e0;
    border-radius: 8px;
  }
  .customs-enter,
  .customs-leave-to {
    opacity: 0;
  }
  .customs-enter-active,
  .customs-leave-active {
    transition: all 0.4s ease;
  }
  .successTips-enter,
  .successTips-leave-to {
    opacity: 0;
  }
  .successTips-enter-active,
  .successTips-leave-active {
    transition: all 0.4s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/top.vue